<template>
  <div class="pb-4 mt-4 card">
    <div class="px-4 sm:px-6 lg:px-8">
      <div class="flow-root ">
        <div class="card-header">
          <span
            class="mb-0 text-lg font-bold"
            style="text-transform: capitalize"
          >
            Customer Chalans
          </span>
        </div>
        <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div
            class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8"
          >
            <table class="min-w-full divide-y divide-gray-300">
              <thead>
                <tr class="bg-gray-50">
                  <th
                    scope="col"
                    class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"
                  >
                    Date
                  </th>
                  <th
                    scope="col"
                    class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"
                  >
                    Branch
                  </th>
                  <th
                    scope="col"
                    class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"
                  >
                    Customer
                  </th>
                  <th
                    scope="col"
                    class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >
                    Status
                  </th>
                  <th
                    scope="col"
                    class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-200">
                <tr v-for="item in customerChalans" :key="item.id">
                  <td
                    class="py-4 pl-4 pr-3 text-sm font-medium text-gray-900 whitespace-nowrap sm:pl-0"
                  >
                    {{ item.date | convertDate }}
                  </td>
                  <td
                    class="py-4 pl-4 pr-3 text-sm font-medium text-gray-900 whitespace-nowrap sm:pl-0"
                  >
                    <span
                      v-if="item.branch === 'Baner'"
                      class="inline-flex items-center px-2 py-1 text-xs font-medium text-red-700 rounded-full bg-red-50 ring-1 ring-inset ring-red-400"
                      >{{ item.branch }}</span
                    >
                    <span
                      v-else
                      class="inline-flex items-center px-2 py-1 text-xs font-medium text-blue-700 rounded-full bg-blue-50 ring-1 ring-inset ring-blue-700/10"
                      >{{ item.branch }}</span
                    >
                  </td>
                  <td class="px-3 py-4 text-sm text-gray-500 whitespace-nowrap">
                    {{ item.user }}
                  </td>
                  <td class="px-3 py-4 text-sm text-gray-500 whitespace-nowrap">
                    {{ item.status }}
                  </td>
                  <td class="px-3 py-4 text-sm text-gray-500 whitespace-nowrap">
                    <div class="relative inline-block text-left">
                      <div>
                        <button
                          type="button"
                          class="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-blue-300 px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-blue-200"
                          id="menu-button"
                          aria-expanded="true"
                          aria-haspopup="true"
                          @click="handleDropdown(item)"
                        >
                          Actions
                        </button>
                      </div>
                      <div
                        v-if="item.isDropdownOpen === true"
                        class="absolute right-0 z-10 w-56 mt-2 origin-top-right bg-white rounded-md shadow-lg ring-1 ring-black/5 focus:outline-none"
                        role="menu"
                        aria-orientation="vertical"
                        aria-labelledby="menu-button"
                        tabindex="-1"
                      >
                        <div class="py-1" role="none">
                          <!-- Active: "bg-gray-100 text-gray-900 outline-none", Not Active: "text-gray-700" -->
                          <span
                            @click="handleEdit(item)"
                            class="block px-4 py-2 text-sm text-gray-700"
                            role="menuitem"
                            tabindex="-1"
                            id="menu-item-0"
                            >Edit</span
                          >
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="flex items-center justify-between px-4 mt-4">
            <!-- Records Per Page Selector -->
            <div class="flex items-center space-x-2">
              <label for="per-page" class="text-sm font-medium"
                >Records per page:</label
              >
              <select
                id="per-page"
                v-model="perPage"
                @change="getcustomerChalans()"
                class="px-2 py-1 border rounded"
              >
                <option
                  v-for="option in perPageOptions"
                  :key="option"
                  :value="option"
                >
                  {{ option }}
                </option>
              </select>
            </div>

            <!-- <Pagination
              :currentPage="pagination.current_page"
              :totalPages="pagination.last_page"
              @page-change="handlePageChange"
            /> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { format } from "date-fns";
import Pagination from "../../components/Pagination.vue";
import { apiHelper } from "../../utils/helpers";
import endpoints from "@/utils/constants";

export default {
  data() {
    return {
      customerChalans: [],
      pagination: {},
      perPage: 10,
      perPageOptions: [5, 10, 25, 50],
      paginationLinks: []
    };
  },
  filters: {
    convertDate(date) {
      return format(date, "DD MMM YYYY");
    }
  },
  components: {
    Pagination
  },
  mounted() {
    this.getCustomerChalans();
  },

  methods: {
    handlePageChange(page) {
      this.getCustomerChalans(
        `/api/v1/customer-chalans?page=${page}&per_page=${this.perPage}`
      );
    },
    getCustomerChalans(
      url = `/api/v1/customer-chalans?page=1&per_page=${this.perPage}`
    ) {
      apiHelper
        .call("get", `${endpoints.LARAVEL_BASE_URL}${url}`)
        .then(response => {
          this.customerChalans = response.data.data.map(i => {
            return {
              ...i,
              isDropdownOpen: false
            };
          });
          this.pagination = {
            current_page: response.data.current_page,
            prev_page_url: response.data.prev_page_url,
            next_page_url: response.data.next_page_url,
            last_page: response.data.last_page
          };
          this.generatePaginationLinks();
        });
    },
    generatePaginationLinks() {
      const links = [];
      for (let i = 1; i <= this.pagination.last_page; i++) {
        links.push({
          number: i,
          url: `/api/v1/customer-chalans?page=${i}&per_page=${this.perPage}`,
          active: i === this.pagination.current_page
        });
      }
      this.paginationLinks = links;
    },
    handleDropdown(item) {
      const data = this.customerChalans.map(i => {
        if (i.id === item.id) {
          return {
            ...i,
            isDropdownOpen: item.isDropdownOpen === true ? false : true
          };
        } else {
          return {
            ...i,
            isDropdownOpen: false
          };
        }
      });
      this.customerChalans = data;
    },
    handleEdit(item) {
      this.$router.push(`/customer-chalans/${item.id}/`);
    }
  }
};
</script>
